module.exports = __webpack_public_path__ + "img/diplome-nourisson.45426b4d.jpg";